import { windowToggler } from "../../reducers/window/windowSlice";

export const newWindow = (isOpen) => (dispatch, getState) => {
  // const currentOpenState = getState().window.openWindow;
  dispatch(windowToggler(isOpen));
};
